import * as React from 'react';
import { SVGProps } from 'react';

const SettingsSidebar = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={props.width || 22}
    height={props.height || 22}
    fill='none'
    viewBox='0 0 22 22'
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      stroke='#A0A4A8'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M11 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z'
    />
    <path
      stroke='#A0A4A8'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M17.167 13.5a1.375 1.375 0 0 0 .275 1.517l.05.05a1.666 1.666 0 0 1-.541 2.72 1.667 1.667 0 0 1-1.818-.362l-.05-.05a1.374 1.374 0 0 0-1.516-.275 1.375 1.375 0 0 0-.834 1.258v.142a1.667 1.667 0 0 1-3.333 0v-.075a1.375 1.375 0 0 0-.9-1.258 1.375 1.375 0 0 0-1.517.275l-.05.05a1.667 1.667 0 1 1-2.358-2.359l.05-.05a1.375 1.375 0 0 0 .275-1.516 1.375 1.375 0 0 0-1.258-.834H3.5a1.667 1.667 0 1 1 0-3.333h.075a1.375 1.375 0 0 0 1.258-.9 1.375 1.375 0 0 0-.275-1.516l-.05-.05a1.667 1.667 0 1 1 2.359-2.359l.05.05a1.375 1.375 0 0 0 1.516.275H8.5a1.375 1.375 0 0 0 .833-1.258V3.5a1.667 1.667 0 0 1 3.334 0v.075a1.375 1.375 0 0 0 .833 1.258 1.375 1.375 0 0 0 1.517-.274l.05-.05a1.667 1.667 0 1 1 2.358 2.358l-.05.05a1.375 1.375 0 0 0-.275 1.517V8.5a1.376 1.376 0 0 0 1.258.834h.142a1.667 1.667 0 1 1 0 3.333h-.075a1.376 1.376 0 0 0-1.258.833v0Z'
    />
  </svg>
);

export default SettingsSidebar;
